import React, { useEffect, useMemo, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router";
import Select from "react-select";

import { selectStyle } from "../../../shared/fixtures/select_style";
import { H2, H4, P } from "../../atoms/Texts";
import { NewFormFooter } from "../../organisms/Footers";
import { demoContext } from "../../../shared/store/contexts";

export const FormOne = ({
  changeStep,
  discard,
  fields,
  updateFields,
  saveToDraft,
}) => {
  const { services: data } = useContext(demoContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    control,
    getValues,
    handleSubmit,
    watch,
    reset,
    formState: { errors: formStateErrors },
  } = useForm();

  useEffect(() => {
    if (fields?.service) {
      reset({
        service: fields.service,
      });
    }
  }, [fields, reset]);

  const services = useMemo(() => {
    return data.map((service) => ({
      label: service.name,
      value: service.id,
    }));
  }, [data]);

  const selectedService = watch("service");

  const updateData = (data) => {
    updateFields(data);
    changeStep(2);
  };

  return (
    <form onSubmit={handleSubmit(updateData)} className="flex-grow">
      <section className="bg-white my-10  pt-16 pb-24 md:w-2/3 mx-auto">
        <div className="text-center mx-auto">
          <H2 fontSize="26px" color="#22202D" className="pb-2.5">
            Choose a service for the form
          </H2>
          <P fontSize="14px" color="#7D7B96">
            Select a service from your available services.
          </P>

          <>
            <div className="my-6 flex flex-col items-start w-1/2 mx-auto">
              <H4 fontSize="16px" color="#22202D" className="pt-6 pb-4">
                Service Name
              </H4>

              <Controller
                control={control}
                id="service"
                name="service"
                render={({ field }) => (
                  <Select
                    {...field}
                    styles={selectStyle}
                    autoComplete="true"
                    options={services}
                    placeholder="--Select Service--"
                    className="w-full"
                  />
                )}
                rules={{
                  required: true,
                }}
                // defaultValue={fields.service ?? ""}
              />
              {formStateErrors.service && (
                <P fontSize="12px" className="mt-2 mb-2 text-red-400 text-sm">
                  Select a service
                </P>
              )}
            </div>
          </>
        </div>
      </section>
      <NewFormFooter
        firstStep
        changeStep={() => handleSubmit(updateData)}
        updateFields={updateData}
        discard={discard}
        saveToDraft={() => {
          const values = getValues();
          saveToDraft(values);
        }}
        disableNext={!selectedService}
      />
    </form>
  );
};
